import { Prefetch } from './Prefetch';

export default Prefetch;
